/* global google */
/* ROLLBACK — original initMap (before mobile radius support):
window.initMap = function () {
    const mapElement = document.querySelector('.map');
    if (!mapElement) { return; }
    const lat = parseFloat(mapElement.dataset.lat);
    const lng = parseFloat(mapElement.dataset.lng);
    const address = mapElement.dataset.query;
    const map = new google.maps.Map(mapElement, {
        zoom: 15, center: { lat: 48.8566, lng: 2.3522 },
        disableDefaultUI: true, zoomControl: true, mapId: 'A_GLASS_MAP_ID'
    });
    const setMapLocation = (destination) => {
        map.setCenter(destination);
        const icon = document.createElement("img");
        icon.src = hsc_data?.icon; icon.width = 40; icon.height = 40;
        new google.maps.marker.AdvancedMarkerElement({ map, position: destination, content: icon });
        mapElement.gmap = { map, destination };
    };
    if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
        setMapLocation({ lat, lng });
    } else if (address) {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': address }, (results, status) => {
            if (status === 'OK') { setMapLocation(results[0].geometry.location); }
            else { mapElement.innerHTML = `<div style="padding:20px;text-align:center;">Could not find address: ${address}</div>`; }
        });
    }
}
END ROLLBACK */
function loadGoogleMapsApi(apiKey) {
    if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
        console.log("Google Maps API уже загружен.");

        if (typeof initMap === 'function') {
            initMap();
        }
        return;
    }
    const script = document.createElement('script');
    // Advanced markers require the beta channel.
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap&libraries=marker&v=beta`;
    script.async = true;
    script.defer = true;

    document.head.appendChild(script);
}
loadGoogleMapsApi(hsc_data?.GOOGLE_MAP_API_KEY);

document.addEventListener('DOMContentLoaded', () => {

    // --- Route building logic (standard centers only) ---
    document.querySelectorAll('a[href="#build-path"]').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            const mapElement = document.querySelector('.map');
            if (!mapElement || !mapElement.gmap) {
                alert('Map is not ready yet.');
                return;
            }

            mapElement.scrollIntoView({ behavior: 'smooth' });

            const { map } = mapElement.gmap;
            const clickedButton = e.currentTarget;
            const lat = parseFloat(clickedButton.dataset.lat);
            const lng = parseFloat(clickedButton.dataset.lng);

            if (isNaN(lat) || isNaN(lng)) {
                alert('Destination coordinates are not valid.');
                return;
            }

            const destination = { lat, lng };

            // Initialize directions services only when needed
            const directionsService = new google.maps.DirectionsService();
            const directionsRenderer = new google.maps.DirectionsRenderer();
            directionsRenderer.setMap(map);

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const origin = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };

                        const request = {
                            origin: origin,
                            destination: destination,
                            travelMode: google.maps.TravelMode.DRIVING
                        };

                        directionsService.route(request, (result, status) => {
                            if (status === 'OK') {
                                directionsRenderer.setDirections(result);
                            } else {
                                window.alert('Directions request failed due to ' + status);
                            }
                        });
                    },
                    () => {
                        alert('Error: The Geolocation service failed or permission was denied.');
                    }
                );
            } else {
                alert("Error: Your browser doesn't support geolocation.");
            }
            return false;
        });
    });
});


/**
 * This function is called by the Google Maps API script once it's loaded.
 * For standard centers: initializes the map and places a custom pin marker.
 * For mobile centers: draws a service-area radius circle instead of a pin.
 */
window.initMap = function () {
    const mapElement = document.querySelector('.map');
    if (!mapElement) {
        return;
    }

    const lat = parseFloat(mapElement.dataset.lat);
    const lng = parseFloat(mapElement.dataset.lng);
    const address = mapElement.dataset.query;
    const radiusKm = parseFloat(mapElement.dataset.radius);
    const isMobile = !isNaN(radiusKm) && radiusKm > 0;

    const map = new google.maps.Map(mapElement, {
        zoom: isMobile ? 10 : 15,
        center: { lat: 48.8566, lng: 2.3522 }, // Default to Paris, will be updated
        disableDefaultUI: true,
        zoomControl: true,
        // A map ID is required for advanced markers.
        mapId: 'A_GLASS_MAP_ID'
    });

    const setMapLocation = (destination) => {
        map.setCenter(destination);

        if (isMobile) {
            // Mobile unit: draw a service-area circle instead of a pin
            new google.maps.Circle({
                map: map,
                center: destination,
                radius: radiusKm * 1000, // convert km → meters
                strokeColor: '#1A6BCC',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#1A6BCC',
                fillOpacity: 0.15,
            });
        } else {
            // Standard center: place custom pin marker
            const icon = document.createElement("img");
            icon.src = hsc_data?.icon;
            icon.width = 40;
            icon.height = 40;
            new google.maps.marker.AdvancedMarkerElement({
                map: map,
                position: destination,
                content: icon,
            });
        }

        // Attach map data to the element for later use in route building
        mapElement.gmap = { map, destination };
    };

    if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
        const destination = { lat, lng };
        setMapLocation(destination);
    } else if (address) {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': address }, (results, status) => {
            if (status === 'OK') {
                const destination = results[0].geometry.location;
                setMapLocation(destination);
            } else {
                console.error(`Geocode was not successful for the following reason: ${status}`);
                mapElement.innerHTML = `<div style="padding: 20px; text-align: center;">Could not find address: ${address}</div>`;
            }
        });
    } else {
        console.error('Map element is missing data-query or data-lat/lng attributes.');
        mapElement.innerHTML = `<div style="padding: 20px; text-align: center;">Could not display map.</div>`;
    }
}
